import Summary_Props_3 from '@components/summaryProps/3'
import React from 'react'
import { RealEstateDataPageComponentData } from 'types'

const Summary_Devs_7 = (props: RealEstateDataPageComponentData) => {
  return (
    <Summary_Props_3
      {...props}
      isDevelopment
    />
  )
}

export default Summary_Devs_7
